'use strict';
var base, base1, base2, detectCurrentLocation, events, extendOnDocumentReady, externalObjectLoader, externalObjectLoaderOnready, getConfigFromDom, hasTouch, loadAsyncJS, makeTag, mediaQueries, pageWidths, ref, ref1, setSiteCookies, trackEvent, unparam;

unparam = require('./unparam');

getConfigFromDom = require('./getConfigFromDom');

trackEvent = require('./trackEvent');

makeTag = require('./makeTag');

loadAsyncJS = require('./loadAsyncJS');

detectCurrentLocation = require('../../../src/frontend/helper/search/helper/m_detectCurrentLocation').detectCurrentLocation;

extendOnDocumentReady = require('./groupon_extended');

setSiteCookies = require('./setSiteCookies');

ref = require('./externalObjectLoader'), externalObjectLoader = ref.externalObjectLoader, externalObjectLoaderOnready = ref.externalObjectLoaderOnready;

if (window.Groupon == null) {
  window.Groupon = {};
}

Object.assign(window.Groupon, {
  SharedJS: {},
  Widgets: {},
  PageFlags: {}
});

hasTouch = (typeof Modernizr !== "undefined" && Modernizr !== null ? (ref1 = Modernizr.touchevents) != null ? ref1.valueOf() : void 0 : void 0) || 'ontouchstart' in window || window.navigator.maxTouchPoints || (window.DocumentTouch && document instanceof DocumentTouch);

events = hasTouch ? 'touchstart' : 'click';

pageWidths = {
  xxl: 1280,
  xl: 1080,
  slsL: 769,
  l: 720,
  m: 600,
  s: 400
};

mediaQueries = {
  xxlMin: "(min-width: " + pageWidths.xxl + "px)",
  xlMin: "(min-width: " + pageWidths.xl + "px)",
  slsLMin: "(min-width:  " + pageWidths.slsL + "px)",
  lMin: "(min-width:  " + pageWidths.l + "px)",
  mMin: "(min-width:  " + pageWidths.m + "px)",
  sMin: "(min-width:  " + pageWidths.s + "px)",
  xxlMax: "(max-width: " + (pageWidths.xxl - 1) + "px)",
  xlMax: "(max-width: " + (pageWidths.xl - 1) + "px)",
  slsLMax: "(max-width:  " + (pageWidths.slsL - 1) + "px)",
  lMax: "(max-width:  " + (pageWidths.l - 1) + "px)",
  mMax: "(max-width:  " + (pageWidths.m - 1) + "px)",
  sMax: "(max-width:  " + (pageWidths.s - 1) + "px)"
};

if ((base = window.Groupon).LS == null) {
  base.LS = {};
}

Object.assign(window.Groupon.LS, {
  hasTouch: hasTouch,
  events: events,
  mediaQueries: mediaQueries,
  pageWidths: pageWidths,
  Header: {}
});

if ((base1 = window.Groupon).Modules == null) {
  base1.Modules = {};
}

if ((base2 = window.Groupon).Utils == null) {
  base2.Utils = {};
}

Object.assign(Groupon.Utils, {
  unparam: unparam,
  makeTag: makeTag,
  getConfigFromDom: getConfigFromDom,
  setSiteCookies: setSiteCookies,
  externalObjectLoader: externalObjectLoader,
  externalObjectLoaderOnready: externalObjectLoaderOnready,
  trackEvent: trackEvent,
  loadAsyncJS: loadAsyncJS,
  detectCurrentLocation: detectCurrentLocation
});

extendOnDocumentReady();

